import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bowser from 'bowser';

// Components
import DoneIcon from '@material-ui/icons/Done';
import SearchTextField from 'components/TextField/SearchTextField';
import PersonListItem from 'components/List/PersonListItem';
import Loader from 'components/Loader';

// Style
import classnames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    loaderRoot: {
      minHeight: 100,
      position: 'relative',
    },
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 40,
    },
    searchTextField: {
      width: '100%',
    },
    suggestions: {
      // boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
      background: '#ffffff',
      zIndex: theme.zIndex.surface,
      textAlign: 'left',
      flex: '1 1 auto',
    },
    suggestion: {
      padding: 10,
      '&:hover': {
        cursor: 'pointer',
        background: 'rgba(68, 138, 255, .1) !important', // theme.palette.accent1Color w/ .1 opactiy
      },

      '&.selected': {
        background: 'rgba(68, 138, 255, .3) !important', // theme.palette.accent1Color w/ .3 opactiy
      },
    },
  };
};

// Component
class PersonAutocomplete extends PureComponent {
  static propTypes = {
    focus: PropTypes.bool,
    placeholder: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    dataSource: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    searchStatus: PropTypes.number.isRequired,
    onFocus: PropTypes.func,
    disabled: PropTypes.bool,
  };

  state = {
    value: '',
    cursorIndex: -1,
  };

  componentDidMount() {
    if (this.props.focus) {
      this.textInput.focus();
    }
  }

  onChange = (e, value) => {
    this.setState({
      value: e.target.value,
    });

    if (e.target.value) {
      this.props.onChange(e.target.value);
    }
  };

  onSelect = index => {
    this.props.onSelect(this.props.dataSource[index].object);
    this.setState({ value: '' });
  };

  onKeyDown = e => {
    const { dataSource } = this.props;
    let cursorIndex = this.state.cursorIndex;

    if (e.key === 'ArrowDown' && cursorIndex + 1 <= dataSource.length - 1) {
      cursorIndex = cursorIndex + 1;
      this.setState({ cursorIndex });
    } else if (e.key === 'ArrowUp' && cursorIndex - 1 >= -1) {
      cursorIndex = cursorIndex - 1;
      this.setState({ cursorIndex });
      e.preventDefault();
    } else if (e.key.length === 1) {
      this.setState({ cursorIndex: -1 });
    } else if (e.key === 'Enter') {
      if (cursorIndex >= 0) {
        this.onSelect(cursorIndex);
      }
    }
  };

  /**
   * Handles browser conditionals.
   */
  textFieldProps = () => {
    let props = {};

    // changes onChange to onInput if on IE11 windows 7
    if (bowser.msie && bowser.version === '11.0') {
      props.onInput = this.onChange;
    } else {
      props.onChange = this.onChange;
    }

    return props;
  };

  renderSuggestions = (items, term, cursorIndex, classes) => {
    if (items.length === 0 || term === '') return null;

    return (
      <div className={classes.suggestions}>
        {items.map((item, index) => {
          const icon = item.selected ? <DoneIcon style={{ fill: 'rgb(26, 195, 107)' }} /> : null;
          const isLast = index + 1 === items.length;
          const selected = index === cursorIndex;
          return (
            <PersonListItem
              key={item.object.id}
              person={item.object}
              divider={!isLast}
              secondaryAction={icon}
              className={classnames(classes.suggestion, { selected: selected })}
              onClick={() => this.onSelect(index)}
            />
          );
        })}
      </div>
    );
  };

  render() {
    const { dataSource, placeholder, classes, searchStatus, disabled } = this.props;

    const suggestions = this.renderSuggestions(
      dataSource,
      this.state.value,
      this.state.cursorIndex,
      classes,
    );

    return (
      <div className={classes.root}>
        <SearchTextField
          value={this.state.value}
          placeholder={placeholder}
          onKeyDown={this.onKeyDown}
          inputRef={input => {
            this.textInput = input;
          }}
          onFocus={this.props.onFocus}
          className={classes.searchTextField}
          disabled={disabled}
          {...this.textFieldProps()}
        />
        <Loader classes={{ root: classes.loaderRoot }} status={searchStatus}>
          {suggestions}
        </Loader>
      </div>
    );
  }
}

export default withStyles(styles)(PersonAutocomplete);
